import { THIRD_PARTY_BILLINGS_ACTIONS, initialThirdPartyBillingsState } from './thirdPartyBillings.types'

/**
 * @param {import('./thirdPartyBillings.types').ThirdPartyBillingsSlice} state
 * @param {Object} action
 */
export function thirdPartyBillingsReducer(state = initialThirdPartyBillingsState, { type, payload }) {
  switch (type) {
    case THIRD_PARTY_BILLINGS_ACTIONS.SET_THIRD_PARTY_BILLINGS:
      return { ...state, data: payload }

    case THIRD_PARTY_BILLINGS_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case THIRD_PARTY_BILLINGS_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case THIRD_PARTY_BILLINGS_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
